module.exports = __webpack_public_path__ + "media/components/publish/images/just_listed_email_alert-46145a8d9cdab507e4705148b64a1ecf.png";